import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Main from 'layouts/Main';
import Container from 'components/Container';

import { Adaptation, Character, Code4Fun, Day1, Day2Goonj2025, Dezainovate, Flok, Genus, Idimatiquex, Marketus, MathRelay, Mooka, Mun, Mythological, Novus, RoboMaster, Veritas } from './components';


const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    <Main>
      <Box>
        <br></br>
        <Typography  variant='h4' align='center' fontWeight={800}>
          GOONJ 2025
        </Typography>
        <br></br>
        <br></br>

        <Typography variant='h6' align='center' fontWeight={700}>
          INTRODUCTION
        </Typography>

        <Box id='Day1' marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>
          <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
“Goonj 2025: Celebrating creativity, intellect, and cultural spirit in every performance.”

<br/>
        </Typography>

          <Typography
            variant={'subtitle1'}
            align='justify'

          >
            National Public School, Yeshwanthpur, proudly hosted its signature inter-school cultural and intellectual extravaganza, Goonj 2025, on Friday, 18 July, and Saturday, 19 July 2025. Spanning two dynamic days, the fest featured an impressive line-up of 27 thoughtfully crafted events curated by 13 distinguished academic departments.
            <br></br>
            <br></br>
            Welcoming enthusiastic participation from students of Classes 3 to 12 representing 23 reputed schools, the fest unfolded over two vibrant days, beginning each morning with a grand inaugural ceremony. During these ceremonies, Principal Ms Sheeja Manoj extended a warm welcome and felicitated the esteemed panel of judges before officially declaring the fest open. Addressing the gathering, she encouraged every participant to give their best, compete with honesty, and cheer for one another—reminding them that this fest is not just about trophies and rankings, but about nurturing connections, building confidence, and shaping character. What followed was a spirited celebration where students showcased their creativity, intellect, and collaborative spirit across an array of events spanning diverse domains.
            <br></br>
            <br></br>
            In the realm of Performing Arts, events like Character Cameo and Janapadakalvaibhava brought stories and folklore to life, while Nrityarupakam celebrated Indian mythology through dance. Beedi Nataka used the power of street theatre to raise social awareness, and the inter-school band competition Rhythmscape electrified audiences with soulful music and energetic rhythms. Art Relay invited young artists to co-create live, blending individual vision into shared masterpieces.
            <br></br>
            <br></br>
            The fest also nurtured Debates & Critical Thinking Skills through events like Debattle, Vaad-Vivaad, Veritas Vincit (moot court), Veritas Interna (psychology and strategy), and Model United Nations, where students debated, analysed, and presented their perspectives on contemporary issues, legal scenarios, and global challenges.
            <br></br>
            <br></br>
            Creativity & Design took centre stage in Idiomatiquex, where idioms became dynamic performances, and in Dezainovate, where students pitched product ideas, tackled real-world design challenges, and created costumes blending contrasting aesthetics. Sci-Fi Sync merged storytelling and improvisation in a science fiction setting, while Adaptation Boogie challenged younger students to blend scientific knowledge with creative model making.
            <br></br>
            <br></br>
            In an age where Technology & Innovation meet imagination, students shone in Code 4 Fun (animated comic strips), Robo Masters (environment-themed robotics), and Code Clash (Python coding challenges). Fusion Frontiers explored architectural science, blending structural analysis and creativity.
            The domain of Business & Negotiation Skills was brought alive through Commerce Maestro, Genus Vincere (a Formula 1-themed business simulation), and Merketus Deus, where students navigated from stock trading floors to boardrooms as angel investors, demonstrating strategic thinking and entrepreneurial flair. 
            Mathematical ingenuity found creative expression in Novus Gra, Chroma Quest, and the fast-paced Math Relay, where students combined speed, strategy, and teamwork. Mooka Paryavaran used the silent power of mime to raise ecological awareness, blending performance and message.
            <br></br>
            <br></br>
            The fest concluded with a lively closing ceremony where Brigade School Malleshwaram claimed the Rolling Trophy. GOONJ 2025 proved to be more than a competition—it was a celebration of collaboration, creativity, and intellect, leaving everyone inspired for the editions to come.
            <br></br>
            <br></br>
          </Typography>
          <br></br>
          <Typography variant='h6' align='center' id='Day1' fontWeight={700}>
            DAY 1
          </Typography>
          <Day1 />
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Character Cameo</Typography>
              <Typography align='right'> - Legendary Lives on Stage</Typography>

            </Box>
            <AccordionDetails>
            Bringing legendary characters to life with expression and imagination.

            </AccordionDetails>

            <Character/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}> Back to DAY 1</a>
            </Box>

          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >IdiomatiqueX</Typography>
              <Typography align='right' > - Idiom Acts Unleashed</Typography>

            </Box>
            <AccordionDetails>
            Turning idioms into lively performances blending wit, teamwork and creativity.
            </AccordionDetails>

            <Idimatiquex />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Mythological Enactment </Typography>
              <Typography align='right' >- Echoes of Epics</Typography>

            </Box>
            <AccordionDetails>
            A journey into the mythological past, with students breathing life into timeless tales.
            </AccordionDetails>

            <Mythological />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Folk Drama</Typography>
              <Typography align='right' >- Folk Fusion Fiesta</Typography>

            </Box>
            <AccordionDetails>
            Celebrating Karnataka's folk heritage through song, costume and narrative.
            </AccordionDetails>

            <Flok/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Novus Gra</Typography>
              <Typography align='right' >- Tangram Tales</Typography>

            </Box>
            <AccordionDetails>
            Where numbers meet creativity — tangrams, puzzles and stories.
            </AccordionDetails>

            <Novus />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Math Relay</Typography>
              <Typography align='right' >- Sprint of Sums</Typography>

            </Box>
            <AccordionDetails>
            High-speed problem solving, teamwork and mathematical mastery in action.
            </AccordionDetails>

            <MathRelay />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Adaptation Boogie</Typography>
              <Typography align='right' >- Adapt, Evolve & Explain</Typography>

            </Box>
            <AccordionDetails>
           Puzzles, models and presentations exploring the wonders of adaptation.
            </AccordionDetails>

            <Adaptation/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Code 4 Fun</Typography>
              <Typography align='right' >- Comic Coders</Typography>


            </Box>
            <AccordionDetails>
            Designing digital comic strips with creativity and code.
            </AccordionDetails>

            <Code4Fun/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>
          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Robo Maters</Typography>
              <Typography align='right' >- Bots for Earth</Typography>


            </Box>
            <AccordionDetails>
            Building robots to serve and protect Mother Earth.
            </AccordionDetails>

            <RoboMaster />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Mooka Paryavaran</Typography>
    <Typography align='right' > - Silent Earth Speaks</Typography>

  </Box>
  <AccordionDetails>
   Silent mime performances that speak loudly for the planet.
  </AccordionDetails>

  <Mooka/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' > Veritas Vincit</Typography>
    <Typography align='right' >- Courtroom Conquests</Typography>

  </Box>
  <AccordionDetails>
  Stepping into courtrooms to argue, question and advocate for justice.
  </AccordionDetails>

  <Veritas />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >NPSYPR MUN </Typography>
    <Typography align='right' >- Diplomats of Tomorrow</Typography>

  </Box>
  <AccordionDetails>
  Students become diplomats, debating and negotiating global issues.
  </AccordionDetails>

  <Mun/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Genus Vincere</Typography>
    <Typography align='right' >- F1 Strategy Drive</Typography>

  </Box>
  <AccordionDetails>
  F1-themed simulations where teams race through strategy and negotiation.
  </AccordionDetails>

  <Genus/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Marketus Deus</Typography>
    <Typography align='right' >- Masters of Markets</Typography>

  </Box>
  <AccordionDetails>
  From mock stock trading to angel investing — mastering the art of finance.
  </AccordionDetails>

  <Marketus/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Dezainovate</Typography>
    <Typography align='right' >- Concepts to Catwalk</Typography>

  </Box>
  <AccordionDetails>
  From imaginative product design to creative problem-solving, culminating in a striking runway showcase of contrasting aesthetics.
  </AccordionDetails>

  <Dezainovate/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>








          <Day2Goonj2025/>

        </Box>
      </Box>
    </Main>
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Goonj2025 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Goonj2025;